export enum SummaryMetric{
	SCORE = 'SCORE',
	CVSS_AVG = 'CVSS_AVG',
	CVSS_SUM = 'CVSS_SUM',
	CVSS_COUNT = 'CVSS_COUNT',
	CVSS_MAX = 'CVSS_MAX',
	CVSS_MIN = 'CVSS_MIN',
	R = 'R',
	I = 'I',
	D = 'D',
}
